import React from "react";
const PerPageSelect = ({
  value,
  onChange,
  options = [1,5, 10, 20, 50, 100, 150],
  size = "sm",
  className = "",
}) => {
  return (
    <select
      className={`form-control form-control-${size} w-auto ${className}`}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
    >
      {options.map((limit) => (
        <option key={limit} value={limit}>
          {limit}
        </option>
      ))}
    </select>
  );
};

export default PerPageSelect;
